import { CancelInvitationModalContent } from "./CancelInvitationModalContent";

export default CancelInvitationModalContent;
